import * as s from 'services/payment.service';
import { fromJS } from 'immutable'; // use of immutablejs for various js operations to simplify our work
import { REQUESTED, FAILED, CLIENT_TOKEN, TRANSACTION_SUCCESS } from './actionTypes';

export function getClientToken(id) { // eslint-disable-line
  return (dispatch) => {
    dispatch({
      type: REQUESTED,
    });
    s.getClientToken(id)
        .then((result) => {
          if (result) {
            dispatch({
              type: CLIENT_TOKEN,
              token: result.client_token,
            });
          }
        })
        .catch((err) => {
          dispatch({
            type: FAILED,
            error: err,
          });
        });
  };
}

export function sendPaymentNonce(payload) { // eslint-disable-line
  return (dispatch) => {
    dispatch({
      type: REQUESTED,
    });
    try {
      s.postSubscription(payload)
            .then((result) => {
              if (result.message) {
                dispatch({
                  type: FAILED,
                  error: result.message,
                });
              } else {
                dispatch({
                  type: TRANSACTION_SUCCESS,
                  transaction: fromJS(result),
                });
              }
            });
    } catch (err) {} // eslint-disable-line
  };
}

export function postSubscriptionCS(payload) { // eslint-disable-line
  return (dispatch) => {
    dispatch({
      type: REQUESTED,
    });
    s.postSubscriptionCS(payload)
            .then((result) => {
              if (result) {
                dispatch({
                  type: TRANSACTION_SUCCESS,
                  transaction: fromJS(result),
                });
              }
            })
            .catch((err) => {
              dispatch({
                type: FAILED,
                error: err,
              });
            });
  };
}




// WEBPACK FOOTER //
// ./src/containers/Payment/actions.js